import { Component, ViewChild } from '@angular/core';
import { EcatMobilePartListComponent } from 'src/app/pages/official-website/ecat/mobile/ecat-mobile-part-list/ecat-mobile-part-list.component';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
@Component({
    selector: 'search-by-material',
    templateUrl: './search-by-material.component.html',
    styleUrls: ['./search-by-material.component.less']
})
export class SearchByMaterialComponent {
    @ViewChild('partList') partList!: EcatMobilePartListComponent;

    searchValue = '';
    isDealerPortal: boolean = false;

    constructor(
        private message: NzMessageService,
        private sharedDataService: SharedDataService) {
        this.sharedDataService.currentData.subscribe(data => {
            this.isDealerPortal = data.isDealerPortal;
        });
    }

    onSearch() {
        if (!this.searchValue || !this.searchValue.trim()) {
            this.message.warning('请输入要查询的配件料号');
            return;
        }
        if (this.partList) {
            // 将搜索值传给子组件
            this.partList.searchValue = this.searchValue;
            // 调用子组件的查询方法
            this.partList.fetchData();
            if (environment.production) {
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const customer = JSON.parse(localStorage.getItem('customer') || '{}');
                (window as any).dataLayer.push({
                    event: 'dp_eact_search_click',
                    from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                    event_type: 'PN',
                    event_name: '',
                    portal_name: 'Mobile ' + (this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount),
                    event_content: this.searchValue,
                });
            }
        }
    }

    onClearSearch() {
        this.searchValue = '';
    }

}
